import React, { useLayoutEffect, useState, useRef } from "react";
import _ from "lodash";
import { BreadcrumbsArrowIcon } from "@netapp/bxp-design-system-react/icons/monochrome";
import styles from "./Breadcrumbs.module.scss"
import classNames from "classnames";
import Popover from "../Popover";
import Tooltip from "./Tooltip";
import { ActionMenuContent } from "../Popover/MenuPopover";

const LastCrumb = ({ child }) => {
    return <div className={styles['last-crumb']}>
        {child}
    </div>
}

const Crumb = ({ child, isOverflow }) => {
    if (isOverflow) {
        return <div className={styles.wrapper}>
            {child}
            <Tooltip>{child.props.children}</Tooltip>
        </div>
    } else {
        return child
    }
}

export default React.memo(({ children, className }) => {
    const [isFirstChildOverflow, setFirstChildIsOverflow] = useState(false);
    const ref = useRef(null);
    const childrenArray = _.isArray(children) ? children : [children];

    useLayoutEffect(() => {
        setTimeout(() => {
            if (ref.current && ref.current.isConnected) {
                const firstChild = ref.current.childNodes[0];
                setFirstChildIsOverflow(firstChild.scrollWidth > firstChild.clientWidth)
            }
        })
    }, []);

    if (!children || childrenArray.length === 0) {
        return "";
    }

    let collapsedGroup = null;

    if (childrenArray.length > 3) {
        collapsedGroup = childrenArray.slice(1, childrenArray.length - 1);
    }

    return <div className={classNames(styles.base, className)} ref={ref}>
        {!collapsedGroup && childrenArray.map((child, index) => {
            const isLast = index === childrenArray.length - 1;

            if(isLast) {
                return <LastCrumb key={index} child={child}/>
            } else {
                return <React.Fragment key={index}>
                    <Crumb child={child} isOverflow={index === 0 && isFirstChildOverflow}/>
                    <BreadcrumbsArrowIcon color="text"/>
                </React.Fragment>
            }
        })}
        {collapsedGroup && <>
            <Crumb child={childrenArray[0]} isOverflow={isFirstChildOverflow}/>
            <BreadcrumbsArrowIcon color="text"/>
            <Popover Content={ActionMenuContent} horizontalPlacement="right" Trigger={() => <div className={styles["dots"]}>
                <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.5 5C7.5 5.69036 6.94036 6.25 6.25 6.25C5.55964 6.25 5 5.69036 5 5C5 4.30964 5.55964 3.75 6.25 3.75C6.94036 3.75 7.5 4.30964 7.5 5ZM11.25 5C11.25 5.69036 10.6904 6.25 10 6.25C9.30964 6.25 8.75 5.69036 8.75 5C8.75 4.30964 9.30964 3.75 10 3.75C10.6904 3.75 11.25 4.30964 11.25 5ZM13.75 6.25C14.4404 6.25 15 5.69036 15 5C15 4.30964 14.4404 3.75 13.75 3.75C13.0596 3.75 12.5 4.30964 12.5 5C12.5 5.69036 13.0596 6.25 13.75 6.25Z"
                          fill="var(--icon-primary)"
                    />
                </svg>
            </div>}>
                {collapsedGroup}
            </Popover>
            <BreadcrumbsArrowIcon color="text"/>
            <LastCrumb child={childrenArray[childrenArray.length - 1]}/>
        </>}
    </div>
});
